import { without } from 'ramda'
import { Roles } from 'utils/consts/userRoles'
import { DATABASE_ROUTE_NAMES } from 'utils/consts/routes/database'
import { databaseFiltersName } from './keys'

const databaseProducersDefaultFilters = [
  databaseFiltersName.synonymsFilter,
  databaseFiltersName.countryFilter,
  databaseFiltersName.sourceFilter,
  databaseFiltersName.legalEntityFilter,
  databaseFiltersName.invalidRecordFilter,
  databaseFiltersName.hasWebsiteFilter,
  databaseFiltersName.hasEmailFilter,
  databaseFiltersName.hasPhoneFilter,
  databaseFiltersName.producerWWLFilter,
  databaseFiltersName.wineRegionEUFilter,
  databaseFiltersName.nationalGITypeFilter,
  databaseFiltersName.geoIndicationFilter,
  databaseFiltersName.specialClassificationFilter,
  databaseFiltersName.wineTypeFilter,
  databaseFiltersName.wineColourFilter,
  databaseFiltersName.sweetnessTypeFilter,
  databaseFiltersName.vintageFilter,
  databaseFiltersName.grapesFilter,
  databaseFiltersName.bottleSizeFilter,
  databaseFiltersName.packageTypeFilter,
  databaseFiltersName.alcoholLevelFilter,
  databaseFiltersName.certificatesFilter,
  databaseFiltersName.wwlRatingFilter,
  databaseFiltersName.usersFilter,
  databaseFiltersName.creationDateFilter,
  databaseFiltersName.lastUpdateFilter,
  databaseFiltersName.checkedByFilter,
]
const databaseWinesDefaultFilters = [
  databaseFiltersName.countryFilter,
  databaseFiltersName.producerFilter,
  databaseFiltersName.producerWWLFilter,
  databaseFiltersName.brandFilter,
  databaseFiltersName.additionalNameFilter,
  databaseFiltersName.withAdditionalNameFilter,
  databaseFiltersName.wineRegionEUFilter,
  databaseFiltersName.nationalGITypeFilter,
  databaseFiltersName.geoIndicationFilter,
  databaseFiltersName.specialClassificationFilter,
  databaseFiltersName.wineTypeFilter,
  databaseFiltersName.wineColourFilter,
  databaseFiltersName.sweetnessTypeFilter,
  databaseFiltersName.vintageFilter,
  databaseFiltersName.onlyLatestVintageFilter,
  databaseFiltersName.grapesFilter,
  databaseFiltersName.hasBottleImageFilter,
  databaseFiltersName.adminPackshotImageFilter,
  databaseFiltersName.hasFrontLabelImageFilter,
  databaseFiltersName.adminFrontLabelImageFilter,
  databaseFiltersName.hasBackLabelImageFilter,
  databaseFiltersName.adminBackLabelImageFilter,
  databaseFiltersName.bottleSizeFilter,
  databaseFiltersName.packageTypeFilter,
  databaseFiltersName.alcoholLevelFilter,
  databaseFiltersName.certificatesFilter,
  databaseFiltersName.wwlRatingFilter,
  databaseFiltersName.havePublicReviewsFilter,
  databaseFiltersName.sourceFilter,
  databaseFiltersName.invalidRecordFilter,
  databaseFiltersName.creationDateFilter,
  databaseFiltersName.checkedByFilter,
]
const databaseBrandsDefaultFilters = [
  databaseFiltersName.usersFilter,
  databaseFiltersName.countryFilter,
  databaseFiltersName.producerFilter,
  databaseFiltersName.registrationFilter,
  databaseFiltersName.sourceFilter,
  databaseFiltersName.creationDateFilter,
  databaseFiltersName.lastUpdateFilter,
  databaseFiltersName.checkedByFilter,
  databaseFiltersName.invalidRecordFilter,
  databaseFiltersName.synonymsFilter,
]
const databaseGeoIndicationDefaultFilters = [
  databaseFiltersName.countryFilter,
  databaseFiltersName.euGITypeFilter,
  databaseFiltersName.nationalGITypeFilter,
  databaseFiltersName.wineRegionEUFilter,
  databaseFiltersName.parentGeoIndicationFilter,
  databaseFiltersName.wineTerritoryTypeFilter,
]
const databaseExhibitionsDefaultFilters = [
  databaseFiltersName.dateStartFilter,
  databaseFiltersName.dateEndFilter,
  databaseFiltersName.countryFilter,
  databaseFiltersName.participantsFilter,
  databaseFiltersName.exhibitionTypeFilter,
]
const databaseKindOfWineDefaultFilters = [
  databaseFiltersName.countryFilter2,
  databaseFiltersName.nationalGITypeFilter,
  databaseFiltersName.geoIndicationFilter,
  databaseFiltersName.wineTypeFilter,
  databaseFiltersName.wineColourFilter,
  databaseFiltersName.sweetnessTypeFilter,
]
const databaseSpecialClassificationConditionDefaultFilters = [
  databaseFiltersName.specialClassificationFilter,
  databaseFiltersName.countryFilter,
  databaseFiltersName.nationalGITypeFilter,
  databaseFiltersName.geoIndicationFilter,
  databaseFiltersName.wineTypeFilter,
  databaseFiltersName.wineColourFilter,
  databaseFiltersName.sweetnessTypeFilter,
]
// указываются списки фильтров и их порядок в зависимости от роута
export const includedDatabaseFiltersOnRoute = {
  [DATABASE_ROUTE_NAMES.databaseProducers]: {
    [Roles.PERSON]: [
      databaseFiltersName.countryFilter,
      databaseFiltersName.wineRegionEUFilter,
      databaseFiltersName.nationalGITypeFilter,
      databaseFiltersName.geoIndicationFilter,
      databaseFiltersName.specialClassificationFilter,
      databaseFiltersName.wineTypeFilter,
      databaseFiltersName.wineColourFilter,
      databaseFiltersName.sweetnessTypeFilter,
      databaseFiltersName.vintageFilter,
      databaseFiltersName.grapesFilter,
      databaseFiltersName.alcoholLevelFilter,
      databaseFiltersName.certificatesFilter,
      databaseFiltersName.bottleSizeFilter,
      databaseFiltersName.packageTypeFilter,
      databaseFiltersName.hasVerifiedRepresentativeFilter,
      databaseFiltersName.wwlRatingFilter,
    ],
    [Roles.CONTENT]: [...databaseProducersDefaultFilters],
    [Roles.SUPERADMIN]: [...databaseProducersDefaultFilters],
    [Roles.MANAGER]: [
      ...without(
        [
          databaseFiltersName.sourceFilter,
          databaseFiltersName.checkedByFilter,
          databaseFiltersName.synonymsFilter,
        ],
        databaseProducersDefaultFilters
      ),
    ],
    default: [
      databaseFiltersName.usersFilter,
      databaseFiltersName.countryFilter,
      databaseFiltersName.creationDateFilter,
      databaseFiltersName.invalidRecordFilter,
    ],
  },
  [DATABASE_ROUTE_NAMES.databaseProducersDuplicates]: {
    [Roles.PERSON]: [databaseFiltersName.countryFilter],
    default: [databaseFiltersName.countryFilter],
  },
  [DATABASE_ROUTE_NAMES.databaseBrands]: {
    [Roles.PERSON]: [
      ...without(
        [
          databaseFiltersName.sourceFilter,
          databaseFiltersName.checkedByFilter,
          databaseFiltersName.synonymsFilter,
        ],
        databaseBrandsDefaultFilters
      ),
    ],
    [Roles.MANAGER]: [
      ...without(
        [
          databaseFiltersName.sourceFilter,
          databaseFiltersName.checkedByFilter,
          databaseFiltersName.synonymsFilter,
        ],
        databaseBrandsDefaultFilters
      ),
    ],
    [Roles.CONTENT]: [...databaseBrandsDefaultFilters],
    [Roles.SUPERADMIN]: [...databaseBrandsDefaultFilters],
    default: [
      databaseFiltersName.countryFilter,
      databaseFiltersName.producerFilter,
      databaseFiltersName.registrationFilter,
      databaseFiltersName.usersFilter,
      databaseFiltersName.sourceFilter,
      databaseFiltersName.creationDateFilter,
      databaseFiltersName.checkedByFilter,
      databaseFiltersName.invalidRecordFilter,
    ],
  },
  [DATABASE_ROUTE_NAMES.databaseWines]: {
    [Roles.PERSON]: [
      // databaseFiltersName.invalidRecordFilter,
      databaseFiltersName.countryFilter,
      databaseFiltersName.producerFilter,
      databaseFiltersName.brandFilter,
      databaseFiltersName.wineRegionEUFilter,
      databaseFiltersName.nationalGITypeFilter,
      databaseFiltersName.geoIndicationFilter,
      databaseFiltersName.specialClassificationFilter,
      databaseFiltersName.wineTypeFilter,
      databaseFiltersName.wineColourFilter,
      databaseFiltersName.sweetnessTypeFilter,
      databaseFiltersName.vintageFilter,
      databaseFiltersName.onlyLatestVintageFilter,
      databaseFiltersName.retailPriceFilter,
      databaseFiltersName.cellarDoorPriceFilter,

      databaseFiltersName.grapesFilter,
      databaseFiltersName.alcoholLevelFilter,
      databaseFiltersName.certificatesFilter,
      databaseFiltersName.bottleSizeFilter,
      databaseFiltersName.packageTypeFilter,
      databaseFiltersName.producerWWLFilter,
      databaseFiltersName.wwlRatingFilter,
      databaseFiltersName.havePublicReviewsFilter,
    ],
    [Roles.CONTENT]: [...databaseWinesDefaultFilters],
    [Roles.ADMIN]: [...databaseWinesDefaultFilters],
    [Roles.SUPERADMIN]: [...databaseWinesDefaultFilters],
    [Roles.MANAGER]: [
      ...without(
        [databaseFiltersName.sourceFilter, databaseFiltersName.checkedByFilter],
        databaseWinesDefaultFilters
      ),
    ],
    default: [
      databaseFiltersName.countryFilter,
      databaseFiltersName.usersFilter,
      databaseFiltersName.sourceFilter,
      databaseFiltersName.creationDateFilter,
      databaseFiltersName.checkedByFilter,
      databaseFiltersName.invalidRecordFilter,
      databaseFiltersName.producerFilter,
      databaseFiltersName.brandFilter,
      databaseFiltersName.euGITypeFilter,
      databaseFiltersName.nationalGITypeFilter,
      databaseFiltersName.wineRegionEUFilter,
      databaseFiltersName.geoIndicationFilter,
      databaseFiltersName.wineTypeFilter,
      databaseFiltersName.wineColourFilter,
      databaseFiltersName.sweetnessTypeFilter,
      databaseFiltersName.vintageFilter,
      databaseFiltersName.bottleSizeFilter,
      databaseFiltersName.packageTypeFilter,
      databaseFiltersName.grapesFilter,
      databaseFiltersName.certificatesFilter,
      databaseFiltersName.wwlRatingFilter,
    ],
  },
  [DATABASE_ROUTE_NAMES.databaseGeoIndication]: {
    [Roles.CONTENT]: [...databaseGeoIndicationDefaultFilters],
    [Roles.SUPERADMIN]: [...databaseGeoIndicationDefaultFilters],
    default: [],
  },
  [DATABASE_ROUTE_NAMES.databaseExhibitions]: {
    default: [...databaseExhibitionsDefaultFilters],
  },
  [DATABASE_ROUTE_NAMES.databaseKindOfWine]: {
    default: [...databaseKindOfWineDefaultFilters],
  },
  [DATABASE_ROUTE_NAMES.databaseSpecClasCondition]: {
    default: [...databaseSpecialClassificationConditionDefaultFilters],
  },
}
